import colorModel from './colorModel.vue';
export default {
  components: {
    colorModel
  },
  props: {
    styleObj: {
      type: Object,
      default() {
        return {};
      }
    },
    pageTitle: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      form: {
        invoiceConfig: {
          //发票填写页配置
          // invoiceHeadType: ['P', 'C'], //纳税人类型: C-一般纳税人 S-小规模纳税人 Q-政府机构/事业单位 P-个人
          // invoiceSendMethod: ['email'] //发票接收方式设置 mobile手机号接收 email邮件接收
        }
      },
      invoiceTit: [{
        label: '个人',
        key: 'P'
      }, {
        label: '公司',
        key: 'C'
      }],
      invoiceReceiptMethod: [{
        label: '手机号接收',
        key: 'mobile'
      }, {
        label: '邮件接收',
        key: 'email'
      }],
      invoiceHeadType: [],
      invoiceReceiptMethods: [],
      colorShow: false
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.form = this.styleObj;
      this.invoiceHeadType = this.form.invoiceConfig.invoiceHeadType;
      this.invoiceReceiptMethods = this.form.invoiceConfig.invoiceSendMethod;
    });
  },
  methods: {
    changeFun() {
      this.$emit('itemChange', this.form);
    },
    titCheckboxChange(e) {
      if (e.length < 1) {
        this.$message.warning(this.$t('必须保留一个抬头类型'));
        this.form.invoiceConfig.invoiceHeadType = this.invoiceHeadType;
      } else {
        this.invoiceHeadType = e;
      }
    },
    receiptcheckboxChange(e) {
      if (e.length < 1) {
        this.$message.warning(this.$t('必须保留一个类型的接收方式'));
        this.form.invoiceConfig.invoiceSendMethod = this.invoiceReceiptMethods;
      } else {
        this.invoiceReceiptMethods = e;
      }
    },
    colorClickFun(val, key) {
      this.colorShow = true;
      this.$nextTick(() => {
        this.$refs.colorRef.init(val, key);
      });
    },
    colorFun(val, key) {
      this.form[key] = val;
      this.changeFun();
      this.colorShow = false;
    }
  }
};